import auth from "./auth";
// const baseUrl = 'http://datest.yunpengai.com'
const baseUrl = "";

// 微信config
export function getwxgzhConfig(data) {
  return auth({
    url: "/api/wxapp/getwxgzhConfig",
    method: "get",
    isTrue: true,
    params: data,
  });
}

// 获取第三方登录信息
// url: 'https://jay.yunpengai.com/api/wxapp/getInfoByCache',
export function getInfoByCache(code) {
  return auth({
    url:
      "https://console-mock.apipost.cn/app/mock/project/ab30ad0a-11f0-461c-c3d8-c421112b0aa5/api/wxapp/getInfoByCache",
    // url: 'https://jay2.yunpengai.com/api/wxapp/getInfoByCache',
    // url: '/api/wxapp/getInfoByCache',
    method: "post",
    isTrue: true,
    params: {
      code,
    },
  });
}

/**
 * 送餐员绑定
 * @param {*} data
 * @returns
 */
/**
 * 送餐员绑定
 * @param {*} shopId
 * @param {*} account 账号, 后台创建账号
 * @param {*} password 密码, 后台创建账号
 * @param {*} openId OPENID, H5的公众号openId,可能是钉钉,微信...
 * @param {*} customerId customerId, 通过 customerId 绑定账号, 适用于
 * @returns
 */
export function delivererBind(account, password) {
  return auth({
    url: baseUrl + "api/wxapp/delivery/deliverer/account/register",
    method: "post",
    data: { account, password },
  });
}

/**
 * 送餐员信息
 * @param {*} shopId
 * @param {*} openId 根据[openId]查询
 * @param {*} customerId 如果不存在[openId],根据[customerId查询]
 * @returns
 */
export function delivererDetail() {
  return auth({
    url: baseUrl + "api/wxapp/delivery/deliverer/account/detail",
    method: "post",
    data: {},
  });
}

/**
 * 负责区域列表
 * @param {*} shopId
 * @returns
 */
export function categoryList(shopId) {
  return auth({
    url: baseUrl + "api/wxapp/delivery/deliverer/category/list",
    method: "post",
    data: { shopId },
  });
}
// 订单列表
export function orderList(data) {
  return auth({
    url: baseUrl + "api/wxapp/delivery/deliverer/order/list",
    method: "post",
    data,
  });
}
// 取消订单
export function orderCancel(data) {
  return auth({
    url: baseUrl + "/das/wxapp/deliverer/order/cancel",
    method: "post",
    data,
  });
}
// 协助点餐菜单
export function mealProductList(data) {
  return auth({
    url: baseUrl + "/das/wxapp/deliverer/meal_product_list",
    method: "post",
    data,
  });
}
// 协助订单
export function orderCreate(data) {
  return auth({
    url: baseUrl + "/das/wxapp/deliverer/order/create",
    method: "post",
    data,
  });
}
// 订单详情
export function orderdetail(data) {
  return auth({
    url: baseUrl + "/das/wxapp/deliverer/order/detail",
    method: "post",
    data,
  });
}
// 订单接单/核销
export function orderscan(data) {
  return auth({
    url: baseUrl + "/das/wxapp/deliverer/order/scan",
    method: "post",
    data,
  });
}
// 送餐员扫床码
export function categoryScan(data) {
  return auth({
    url: baseUrl + "/das/wxapp/deliverer/category/scan",
    method: "post",
    data,
  });
}

// 手动接单
export function orderBind(data) {
  return auth({
    url: baseUrl + "/delivery/deliverer/order/status",
    method: "post",
    data,
  });
}

// 送餐员接单
export function orderToReceived(orderNo, isAll) {
  return auth({
    url: baseUrl + "/api/wxapp/delivery/deliverer/order/received",
    method: "post",
    data: {
      orderNo,
      isAll,
    },
  });
}

// 送餐员送达
export function orderToFinish(orderNo) {
  return auth({
    url: baseUrl + "/api/wxapp/delivery/deliverer/order/finish",
    method: "post",
    data: {
      orderNo,
    },
  });
}

// 订单支付
export function orderPay(data) {
  return auth({
    url: baseUrl + "/das/wxapp/customer/order/pay",
    method: "post",
    data: data,
  });
}
